import { component } from 'picoapp'
import moment from 'moment'
require('moment-timezone')

class ProductCard {

  constructor(node, ctx) {
    // Selectors
    this._node = node;
    this._discounted_price = this._node.querySelector('.discounted-price');
    this._regular_price = this._node.querySelector('.regular-price');

    if (this._discounted_price && this._regular_price) {
      let tz = moment.tz.guess(),
          now = moment(new Date(), 'YYYY-MM-DD HH:mm:ss').tz(tz),
          now_et = moment(new Date(), 'YYYY-MM-DD HH:mm:ss').tz('America/New_York'),
          discount_start = moment(this._discounted_price.getAttribute('data-start'), 'YYYY-MM-DD HH:mm:ss').tz('America/New_York').startOf('day'),
          discount_end = moment(this._discounted_price.getAttribute('data-end'), 'YYYY-MM-DD HH:mm:ss').tz('America/New_York').startOf('day');

      if (discount_start.isBefore(now) && now.isBefore(discount_end)) {
        this._discounted_price.style.display = "flex";
        this._regular_price.style.display = "none";
      } else {
        this._discounted_price.style.display = "none";
        this._regular_price.style.display = "flex";
      }
    }

    this.unmount.bind(this)
  }

  //
  // Unmount.
  //
  unmount() {

  }
}

export default component((node, ctx) => new ProductCard(node, ctx))
